import React from 'react';
import { Link as RouterLink } from 'react-router-dom'; // For the back link

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: '2rem auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'sans-serif',
    color: '#333',
  },
  title: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: '#333',
    fontSize: '2.5em',
  },
  sectionTitle: {
    marginTop: '2.5rem',
    marginBottom: '1.2rem',
    fontSize: '1.75em',
    color: '#444',
    borderBottom: '2px solid #007bff',
    paddingBottom: '0.6rem',
  },
  paragraph: {
    lineHeight: '1.7',
    marginBottom: '1.2rem',
    color: '#555',
    fontSize: '1.05em',
  },
  address: {
    lineHeight: '1.7',
    marginBottom: '1.2rem',
    fontStyle: 'normal',
    color: '#555',
    fontSize: '1.05em',
  },
  highlight: {
    color: '#007bff',
    fontWeight: 'bold',
  },
  backLinkContainer: {
    marginTop: '3.5rem',
    textAlign: 'center',
  },
  backLink: {
    color: '#007bff',
    textDecoration: 'underline',
    fontSize: '1em',
  },
};

function AboutUsPage() {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>About CodeMates Software Limited</h1>

      <h2 style={styles.sectionTitle}>Company Information</h2>
      <p style={styles.paragraph}><strong>CodeMates Software Limited</strong></p>
      <address style={styles.address}>
        RM 1805-06 18/F HOLLYWOOD PLZ<br />
        610 NATHAN RD<br />
        MONGKOK, HONG KONG
      </address>
      <p style={styles.paragraph}><strong>Telephone:</strong> +1 478-200-9849</p>
      <p style={styles.paragraph}>
        For support, inquiries, or partnership opportunities, please email us at{' '}
        <a href="mailto:support@codemates.app" style={{color: '#007bff', fontWeight: 'bold'}}>support@codemates.app</a>.
      </p>

      <h2 style={styles.sectionTitle}>Our Mission</h2>
      <p style={styles.paragraph}>
        At CodeMates Software Limited, our core mission is to <span style={styles.highlight}>empower individuals and businesses</span> by crafting innovative, user-friendly, and reliable applications. We believe that technology should simplify complexities and enhance daily lives. We are dedicated to developing high-quality software solutions that are accessible and beneficial to a global audience, helping people achieve more with intuitive digital tools.
      </p>
      <p style={styles.paragraph}>
        We strive to be at the forefront of mobile and web application development, focusing on creating products that are not only functional but also enjoyable to use. Our goal is to provide <span style={styles.highlight}>good apps for people around the globe</span>, fostering a community of users who find value and efficiency through our software.
      </p>

      <h2 style={styles.sectionTitle}>Who We Are</h2>
      <p style={styles.paragraph}>
        CodeMates Software Limited is a passionate team of developers, designers, and strategists headquartered in Hong Kong. Founded with a vision to make a tangible impact through technology, we combine our diverse expertise to build applications that address real-world needs. We are committed to continuous learning and improvement, ensuring our products evolve with the ever-changing technological landscape.
      </p>
      <p style={styles.paragraph}>
        Our approach is user-centric. We listen to feedback, analyze trends, and meticulously design each feature to provide the best possible experience. From utility apps that streamline tasks to platforms that connect people, our portfolio is built on a foundation of <span style={styles.highlight}>quality, integrity, and innovation</span>.
      </p>
      
      <div style={styles.backLinkContainer}>
        <RouterLink to="/" style={styles.backLink}>
          &larr; Go back to home
        </RouterLink>
      </div>
    </div>
  );
}

export default AboutUsPage; 